<template>
    <div class="cmn-func-meta-list">
        <div v-for="func in funcListX" class="item" :class="{'selected' : isSelected(func)}" @click="handleClick(func)" @dblclick="handleDblClick(func)">
            <span>{{ func.fullName }} - {{ func.dispTpl }}</span>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'

    import { toJavaShortTypeName, javaShortTypeCompatible } from './Cmn'

    export default {
        name: 'swb-cmn-func-meta-list',
        desc: '通用函数元数据列表',
        props: {
            //所有函数列表
            funcList: {
                type: Array,
                default() {
                    return [];
                }
            },
            //第一参数类型（如果是数组则后加[]表示）
            baseType: {//string, integer, float, boolean, date, map
                type: String,
                default: null
            },
            //初始选中的函数名称
            funcName: {
                type: String
            },
            dblClickHandler: {
                type: Function
            }
        },
        data() {
            return {
                //过滤过的函数列表
                funcListX: [],
                //
                selected: null
            };
        },
        watch: {
            funcList(newVal, oldval) {
                this.initData();
            },
            baseType(newVal, oldval) {
                this.initData();
            },
            funcName(newVal, oldval) {
                this.initData();
            }
        },
        mounted() {
            this.initData();
        },
        beforeDestroy() {
            //data
            this.funcListX = null;
            this.selected = null;
            //props
            this.funcList = null;
            this.dblClickHandler = null;
        },
        methods: {
            initData() {
                let funcList = this.funcList || [];
                let funcName = this.funcName || null;
                let baseType = toJavaShortTypeName(this.baseType || null);
                let funcListX = funcList;
                if(baseType != null) {
                    let itemType = null;
                    funcListX = funcList.filter(function (item) {
                        itemType = toJavaShortTypeName((item.argTypeNames || []).first()) || "";
                        return javaShortTypeCompatible(baseType, itemType);
                    });
                }
                //查找并选中
                this.selected = funcName ? funcListX.find(function (func, index) {
                    return func.fullName == funcName;
                }) : null;
                //
                this.funcListX = funcListX;
            },
            isSelected(funcOrName) {
                let fullName = funcOrName || null;
                if(Utils.isPlainObject(funcOrName)) {
                    fullName = funcOrName.fullName;
                }
                return this.selected == null ? false : fullName == this.selected.fullName;
            },
            handleClick(func) {
                this.selected = func;
            },
            handleDblClick(func) {
                this.selected = func;
                //
                let selected = this.selected == null ? null : Utils.merge(this.selected);
                if(this.dblClickHandler) {
                    this.dblClickHandler.call(this.$parent, selected);
                }
                else {
                    console.log(selected);
                }
            },
            //
            getSelected() {
                return this.selected == null ? null : Utils.merge(this.selected);
            }
        }

    }


</script>

<style>
    .cmn-func-meta-list .item {
        height: 34px;
        line-height: 34px;
        padding: 0 4px;
    }

    .cmn-func-meta-list .item:hover {
        background-color: #EEEEEE;
    }

    .cmn-func-meta-list .item.selected {
        background-color: #fdf5e6;
        color: navy;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/CmnFuncMetaList.vue